<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  tabindex="0"
  (keydown.enter)="handleSubmit()"
  fxLayout="column"
  fxLayoutAlign.gt-xs="center center"
  fxLayoutAlign.lt-sm="start center"
  [ngClass]="isCustomerView || isWidget ? '' : 'nvc-height-95'"
  fxLayoutGap="1rem"
>
  <div
    [ngClass]="{
      'nvs-widget-icon': isWidget,
      'nvs-icon': !isWidget && !isTabDevice(),
      'nvc-width-hundred': !isWidget && isTabDevice(),
      'nvc-margin-top-28': isCustomerView && !isTabDevice(),
      'nvc-margin-bottom-tab-10 nvc-margin-top-10 nvc-padding-tab':
        isCustomerView && isTabDevice()
    }"
    fxLayout="row"
    [fxLayoutAlign]="isCustomerView ? 'space-between center' : 'start center'"
  >
    <mat-icon
      *ngIf="!isCustomerView"
      class="place-self-center ws-cursor-pointer notranslate"
      [ngClass]="{ 'fa fa-chevron-left': isWidget }"
      (click)="backToHome()"
      [svgIcon]="!isWidget ? 'arrow_back' : ''"
      fxLayoutAlign="center center"
    >
    </mat-icon>
    <img
      (click)="backToHome()"
      *ngIf="!isWidget"
      class="whiteshop-logo ws-cursor-pointer"
      [src]="whiteShopIcon"
      alt="whiteShopIcon"
    />
    <div
      *ngIf="isWidget"
      fxFlex="90"
      class="nvs-text-one nvc-font-weight-normal sc-font-20 nvc-text-align-center ws-bold"
    >
      {{
        isPassword ? "Reset Password" : isOtp ? "Enter OTP" : "Forgot Password"
      }}
    </div>

    <mat-icon
      *ngIf="isCustomerView"
      class="ws-cursor-pointer nvc-close-main"
      fxFlexOffset="30"
      (click)="backToHome()"
      fxLayoutAlign="center center"
    >
      close</mat-icon
    >
  </div>
  <div
    *ngIf="isWidget && !isOtp && !isPassword"
    class="nvc-font-weight-normal sc-black nvc-input-div-widget sc-font-13"
  >
    {{ getEmailOrPhoneLabel(true) }}
  </div>
  <div
    *ngIf="!isOtp && !isPassword"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap.gt-xs="1rem"
    fxLayoutGap.lt-sm="2rem"
    [formGroup]="userForm"
    (keyup.enter)="formSubmit()"
    class="nvc-margin-2"
    [ngClass]="isWidget ? '' : 'nvc-margin-4'"
  >
    <div
      class="nvs-text-one nvc-font-weight-normal"
      *ngIf="!isWidget"
      [ngClass]="{
        'ws-bold sc-font-28': isCustomerView,
        'sc-width-90': isCustomerView && !isTabDevice()
      }"
    >
      Forgot password
    </div>
    <div
      class="nvc-font-weight-normal sc-black"
      *ngIf="isCustomerView"
      [ngClass]="{
        'sc-width-90': !isTabDevice()
      }"
    >
      {{ getEmailOrPhoneLabel(true) }}
    </div>
    <div fxLayoutGap="0.5rem" class="nvc-text-align-center">
      <mat-form-field
        appearance="outline"
        class="sc-mat-form-input"
        [ngClass]="{
          'nvc-input-div-widget nvc-margin-top-2 nvc-username-div-widget': isWidget,
          'nvc-input-div': !isWidget,
          'nvc-width-35': !isWidget && isTabDevice()
        }"
      >
        <mat-label class="sc-input-label">{{
          getEmailOrPhoneLabel()
        }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="username"
          autofocus
          (blur)="
            !userForm.controls.username.dirty
              ? userForm.controls.username.markAsUntouched()
              : ''
          "
        />
      </mat-form-field>

      <div
        *ngIf="
          userForm.controls.username.dirty &&
          userForm.controls.username.touched &&
          !isDataValid()
        "
        class="nvc-error-margin"
      >
        <mat-label class="nvc-red">* Enter valid username</mat-label>
      </div>
    </div>
  </div>
  <div
    *ngIf="isOtp && !isPassword"
    class="nvc-margin-2"
    [ngClass]="
      isWidget
        ? 'nvc-input-div-widget'
        : isTabDevice()
        ? 'nvc-width-100'
        : 'nvc-input-div nvc-margin-4'
    "
    fxLayout="column"
    [fxLayoutAlign]="isTabDevice ? 'center center' : 'center start'"
    fxLayoutGap.gt-xs="1rem"
    fxLayoutGap.lt-sm="2rem"
    (keyup.enter)="formSubmit()"
  >
    <div
      class="nvs-text-one nvc-font-weight-normal"
      [ngClass]="{
        'ws-bold ': isWidget || isCustomerView,
        'sc-font-20': isWidget,
        'sc-font-28 sc-line-height-35': isCustomerView
      }"
    >
      <span *ngIf="!(isWidget || isCustomerView)"
        >Check your email for a code</span
      >
      <span *ngIf="isCustomerView">Enter OTP</span>
    </div>
    <div
      class="sc-black nvc-font-weight-normal"
      [ngClass]="isWidget ? 'sc-font-13' : ''"
    >
      OTP has been sent
      <b class="">{{ codeResent }}</b> to
      <b class="">{{ userForm.controls.username.value }}</b>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-evenly center"
      fxLayoutGap="1em"
      [formGroup]="otpForm"
      class="sc-max-width-otp"
    >
      <input
        #box1
        formControlName="box1"
        class="nvs-input-otp border-focus-blue"
        [ngClass]="isWidget ? 'nvs-input-otp-widget' : ''"
        type="tel"
        (input)="onKeyUpFunction(1)"
        (keydown)="backPressEvent(1, $event)"
        (click)="focus(1)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box2
        formControlName="box2"
        class="nvs-input-otp border-focus-blue"
        [ngClass]="isWidget ? 'nvs-input-otp-widget' : ''"
        type="tel"
        (input)="onKeyUpFunction(2)"
        (keydown)="backPressEvent(2, $event)"
        (click)="focus(2)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box3
        formControlName="box3"
        class="nvs-input-otp border-focus-blue"
        [ngClass]="isWidget ? 'nvs-input-otp-widget' : ''"
        type="tel"
        (input)="onKeyUpFunction(3)"
        (keydown)="backPressEvent(3, $event)"
        (click)="focus(3)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box4
        formControlName="box4"
        class="nvs-input-otp border-focus-blue"
        [ngClass]="isWidget ? 'nvs-input-otp-widget' : ''"
        type="tel"
        (input)="onKeyUpFunction(4)"
        (keydown)="backPressEvent(4, $event)"
        (click)="focus(4)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box5
        formControlName="box5"
        class="nvs-input-otp border-focus-blue"
        [ngClass]="isWidget ? 'nvs-input-otp-widget' : ''"
        type="tel"
        (input)="onKeyUpFunction(5)"
        (keydown)="backPressEvent(5, $event)"
        (click)="focus(5)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box6
        formControlName="box6"
        class="nvs-input-otp border-focus-blue"
        [ngClass]="isWidget ? 'nvs-input-otp-widget' : ''"
        type="tel"
        (input)="onKeyUpFunction(6)"
        (keydown)="backPressEvent(6, $event)"
        (click)="focus(6)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
    </div>
  </div>

  <div
    fxLayout="column"
    class="nvc-margin-2"
    [ngClass]="
      isWidget
        ? 'nvc-input-div-widget nvc-width-hundred nvc-position-relative'
        : 'nvc-input-div nvc-margin-4'
    "
    *ngIf="isPassword"
    fxLayoutAlign="start center"
    fxLayoutGap="5px"
    (keyup.enter)="formSubmit()"
  >
    <div class="ws-bold sc-font-28 nvc-width-hundred" *ngIf="isCustomerView">
      Reset Password
    </div>
    <div
      class="nvc-font-weight-normal sc-black nvc-margin-bottom"
      *ngIf="isCustomerView"
      [ngClass]="{
        'nvc-width-hundred': isCustomerView,
        'nvc-input-div-widget sc-font-13': isWidget
      }"
    >
      Enter your new password.
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="nvc-width-hundred">
      <mat-form-field
        appearance="outline"
        class="sc-mat-form-input nvc-width-hundred"
      >
        <mat-label class="sc-input-label">Password</mat-label>
        <input matInput [type]="passwordType1" [(ngModel)]="password" />
        <mat-icon
          matSuffix
          [svgIcon]="passwordVisibility1 ? 'eyeIcon' : 'eyeSlashIcon'"
          class="nvc-eye ws-cursor-pointer"
          (click)="togglePasswordVisibility('password')"
        >
        </mat-icon>
      </mat-form-field>
    </div>
    <div
      *ngIf="confirmPassword && !password"
      class="nvc-width-hundred nvc-padding-left"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <mat-label class="nvc-red">Enter new Password </mat-label>
    </div>
    <div
      class="nvc-margin-bottom nvc-red nvc-width-ninty"
      [ngClass]="{
        'sc-calc-width-1': isWidget,
        'nvc-width-25': isCustomerView
      }"
      *ngIf="!validPassword()"
    >
      *Minimum 8 characters required
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="nvc-width-hundred">
      <mat-form-field
        appearance="outline"
        class="sc-mat-form-input nvc-width-hundred"
      >
        <mat-label class="sc-input-label">Confirm Password</mat-label>
        <input
          matInput
          [type]="passwordType2"
          [(ngModel)]="confirmPassword"
          required
          #passwordTwo
        />
        <mat-icon
          matSuffix
          [svgIcon]="passwordVisibility2 ? 'eyeIcon' : 'eyeSlashIcon'"
          class="nvc-eye ws-cursor-pointer"
          (click)="togglePasswordVisibility('confirmPassword')"
        >
        </mat-icon>
      </mat-form-field>
    </div>
    <div
      *ngIf="confirmPassword && password && confirmPassword !== password"
      [ngClass]="{
        'sc-calc-width-1': isWidget,
        'nvc-width-25': isCustomerView
      }"
    >
      <mat-label class="nvc-red nvc-width-ninty nvc-password-mismatch"
        >Password mismatch</mat-label
      >
    </div>
  </div>
  <div
    fxLayout="column"
    [ngClass]="
      isWidget
        ? 'nvc-input-div-widget nvs-width-90'
        : isTabDevice()
        ? 'nvc-width-100'
        : 'nvc-input-div nvs-width-26'
    "
    [fxLayoutAlign]="
      isWidget || isCustomerView ? 'center center' : 'center start'
    "
    fxLayoutGap="1rem"
  >
    <button
      class="button-shadow-focus ws-cursor-pointer ws-border-none ws-outline-none"
      *ngIf="!isOtp && !isPassword"
      (click)="submit('username')"
      [disabled]="!userForm.controls.username.value && !isDataValid()"
      [ngClass]="{
        'nvc-disabled ws-no-cursor-pointer': !isDataValid(),
        'nvc-button-register-widget': isWidget,
        'nvc-button-register': !isWidget,
        'sc-font-14 nvc-customer-button-register': isCustomerView,
        'ws-bold': isCustomerView || isWidget,
        'nvc-uppercase': !isCustomerView && !isWidget,
        'nvc-width-25': isTabDevice() && isCustomerView
      }"
    >
      Submit
    </button>
    <button
      *ngIf="isOtp && !isPassword"
      class="nvs-text-resend border-focus-blue button-clear ws-cursor-pointer"
      (click)="submit('username')"
    >
      Resend code <b>{{ codeResent }}</b>
    </button>
    <button
      class="button-shadow-focus ws-cursor-pointer ws-border-none ws-outline-none"
      *ngIf="isOtp && !isPassword && otpForm.valid"
      (click)="submit('otp')"
      [disabled]="!otpForm.valid"
      [ngClass]="{
        'nvc-disabled ws-no-cursor-pointer': !otpForm.valid,
        'nvc-button-register-widget': isWidget,
        'nvc-button-register': !isWidget,
        'sc-font-14 nvc-customer-button-register': isCustomerView,
        'ws-bold': isCustomerView || isWidget,
        'nvc-uppercase': !isCustomerView && !isWidget
      }"
    >
      Submit
    </button>
    <button
      class="button-shadow-focus ws-cursor-pointer ws-border-none ws-outline-none"
      *ngIf="isPassword"
      (click)="submit('password')"
      [disabled]="
        !(
          password &&
          confirmPassword &&
          password.length > 7 &&
          password === confirmPassword
        )
      "
      [ngClass]="{
        'nvc-disabled ws-no-cursor-pointer': !(
          password &&
          confirmPassword &&
          password.length > 7 &&
          password === confirmPassword
        ),
        'nvc-button-register-widget': isWidget,
        'nvc-button-register': !isWidget,
        'sc-font-14 nvc-customer-button-register': isCustomerView,
        'ws-bold': isCustomerView || isWidget,
        'nvc-uppercase': !isCustomerView && !isWidget
      }"
    >
      Submit
    </button>
  </div>
  <div
    class="nvs-text-terms nvc-font-weight-normal nvs-width-26"
    *ngIf="!(isWidget || isCustomerView)"
  >
    By providing your email you are agreeing to our
    <span>Terms & Conditions</span>
  </div>
</div>
